import React from "react";
import { Link } from "react-router-dom";

import styled from "styled-components/macro";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";

import "./NewSignupButton.scss";

export default function NewSignupButton() {
  return (
    <div className="create_signup_button_holder">
      <SLink to="/signups/new">
        <FnrButton
          color="blue"
          size="large"
          data-cy="create-new-signup-button"
          // style={{ width: "100%" }}
        >
          <ButtonIcon fas fa-plus-circle />
          <ButtonTextStyled>Create a new Signup</ButtonTextStyled>
        </FnrButton>
      </SLink>
    </div>
  );
}

const ButtonTextStyled = styled(ButtonText)`
  font-size: 19px;
`;

const SLink = styled(Link)`
  text-decoration: none;

  &:hover, &:focus, &:active {
    text-decoration: none !important;
  }
`;